import * as React from 'react'
import { faCheck } from '@fortawesome/pro-light-svg-icons'

import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/pipeable'

import { DateTime } from '@espoon-voltti/ts-libs/lib/time'

import { Section } from '@espoon-voltti/react-components/layout'
import { Columns, Column, Icon } from '@espoon-voltti/react-components/elements'

import { Representative } from '@espoon-voltti/nuora-domain/applicants'

import { Signer } from '../../../domain/grants'

import { t } from '../../../i18n'

interface SignersProps {
  representatives: Representative[]
  signers: Signer[]
}
export const Signers: React.FC<SignersProps> = (p) => (
  <Section>
    {p.representatives.map((r) =>
      pipe(
        O.fromNullable(p.signers.find((x) => x.ssnHash === r.ssnHash)),
        O.map((x) => (
          <SignerRow key={r.ssnHash} signer={r} signedAt={x.signedAt} />
        )),
        O.toNullable
      )
    )}
  </Section>
)

interface SignerRowProps {
  signer: Representative
  signedAt: DateTime
}
const SignerRow: React.FC<SignerRowProps> = (p) => (
  <Columns dataQa={'signer'}>
    <Column dataQa={'roleAndName'}>
      <div>
        <strong>{t(['org', 'representativeRole', p.signer.role])}</strong>
      </div>
      <div>
        {p.signer.firstName} {p.signer.lastName}
      </div>
      <div>{p.signer.email}</div>
    </Column>
    <Column size={4} dataQa={'signedAt'}>
      <Icon status={'success'} icon={faCheck} size={'small'} round={true} />
      <strong>
        {' '}
        {t(['views', 'preview', 'signing', 'signedAt'], {
          date: p.signedAt.format()
        })}
      </strong>
    </Column>
  </Columns>
)
